// extracted by mini-css-extract-plugin
export var columns = "StylizedHeadlineCallout-module--columns--a7216";
export var evergreenDeep = "StylizedHeadlineCallout-module--evergreen-deep--e3de6";
export var floating = "StylizedHeadlineCallout-module--floating--39ef3";
export var image = "StylizedHeadlineCallout-module--image--9a345";
export var stylizedHeadlineHeader = "StylizedHeadlineCallout-module--stylized-headline-header--9f52f";